import React, { useEffect } from "react";

const ActivateAccount = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location = "/SignIn";
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
      <h4>Please check your register Mail Id to Activate your account.<center><h6>Redirecting to SignIn.....</h6></center></h4>
    </div>
  );
}

export default ActivateAccount;

